import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';
import { AgregarFamilias } from "../modals/modalAgregarFamiliar";
import moment from "moment";

const headCells = [
  {
    id: "cedFamiliar",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cédula Familiar",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
  {
    id: "sexo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Sexo",
    textAlign: "center",
  },
  {
    id: "nacionalidad",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nacionalidad",
    textAlign: "center",
  },
  {
    id: "fecNacimiento",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha Nacimiento",
    textAlign: "center",
  },
  {
    id: "parentesco",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Parentesco",
    textAlign: "center",
  },
];

export default function TablaFamiliares(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [records, setRecords] = useState([]);
  const [mostrar, setMostrar] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [activate, setActivate] = useState(false);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: "", texto: "", icono: "" });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => items,
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  // ============================================
  // SELECCIONAR FAMILIARES DESDE BD (modo BD)
  // ============================================
  const seleccionarFamiliares = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codIntegrante}&nomtab=familiares&nomid=codint&bloquear=true`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando familiares:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al cargar familiares",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  // Cargar datos según el modo
  useEffect(() => {
    if (props.codIntegrante) {
      if (props.operacionintegrante === 1) {
        // MODO LOCAL: empezar con array vacío
        setRecords([]);
      } else {
        // MODO BD: cargar desde la base de datos
        seleccionarFamiliares(props.codIntegrante);
      }
    }
  }, [props.codIntegrante, props.operacionintegrante]);

  // ============================================
  // FUNCIÓN PARA ACTUALIZAR FAMILIAR EN BD (MODO BD)
  // Basada en el código Java FrmTblFamiliares
  // ============================================
  const actualizarFamiliarBD = async (datosFamiliar) => {
    if (!props.codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Determinar la operación:
      // 1: Incluir, 2: Editar, 3: Eliminar
      let operBD = operacion;

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/familiares_act?operacion=${operacion}`,

        data: {
          ccodint: props.codIntegrante,                    // Código del integrante
          ccedfam: datosFamiliar?.cedfam || 0,             // Cédula del familiar
          cnacfam: datosFamiliar?.nacfam || "",            // Nacionalidad del familiar
          cnomfam: datosFamiliar?.nomfam || "",            // Nombre del familiar
          cfecnac: datosFamiliar?.fecnac || null,          // Fecha de nacimiento
          cparent: datosFamiliar?.parent || "",            // Parentesco
          cestfam: datosFamiliar?.estudia ? 1 : 0,         // Estudia (boolean a número)
          cgraest: datosFamiliar?.gradoestudio || "",      // Grado de estudio
          cinsest: datosFamiliar?.instituto || "",         // Instituto
          csexfam: datosFamiliar?.sexo === 'FEMENINO' ? 1 : 2,  // Sexo (1=Femenino, 2=Masculino)
          esquema: esquema                                  // Esquema de la base de datos
        },
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Recargar la lista después de la operación
        seleccionarFamiliares(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: `Familiar ${operBD === 1 ? 'agregado' : operBD === 2 ? 'actualizado' : 'eliminado'} correctamente`,
          icono: "success"
        });

        // Limpiar selección
        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error en operación con familiar:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al procesar la solicitud",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  // ============================================
  // FUNCIÓN PARA ELIMINAR FAMILIAR DE BD (MODO BD)
  // ============================================
  const eliminarFamiliarBD = async () => {
    if (!props.codIntegrante || !itemSeleccionado) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      const response = await axios({
        method: 'DELETE',
        url: `${op.conexion}/api/nomina/familiares_act`,
        data: {
          ccodint: props.codIntegrante,
          ccedfam: itemSeleccionado.cedfam,
          cnacfam: itemSeleccionado.nacfam || "",
          operacion: 3, // Eliminar
          esquema: esquema
        },
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Recargar la lista después de eliminar
        await seleccionarFamiliares(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: "Familiar eliminado correctamente",
          icono: "success"
        });

        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error eliminando familiar:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al eliminar el familiar",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  // ============================================
  // MANEJADOR PRINCIPAL DEL MODAL
  // ============================================
  const handleAceptarModal = (datosFamiliar) => {

    if (props.operacionintegrante === 1) {
      // ===== MODO LOCAL =====
      let nuevosRecords = [...records];

      if (operacion === 1) {
        // Nuevo familiar
        nuevosRecords.push({
          cedfam: parseInt(datosFamiliar.cedfam),
          nomfam: datosFamiliar.nomfam,
          sexfam: datosFamiliar.sexo === 'FEMENINO' ? 1 : 2,
          nacfam: datosFamiliar.nacfam,
          fecnac: datosFamiliar.fecnac,
          parent: datosFamiliar.parent,
          estudia: datosFamiliar.estudia,
          gradoestudio: datosFamiliar.gradoestudio,
          instituto: datosFamiliar.instituto
        });
      } else if (operacion === 2) {
        // Editar familiar
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          nuevosRecords[itemSeleccionado.index] = {
            ...nuevosRecords[itemSeleccionado.index],
            cedfam: parseInt(datosFamiliar.cedfam) || nuevosRecords[itemSeleccionado.index].cedfam,
            nomfam: datosFamiliar.nomfam || nuevosRecords[itemSeleccionado.index].nomfam,
            sexfam: datosFamiliar.sexo === 'FEMENINO' ? 1 : 2,
            nacfam: datosFamiliar.nacfam || nuevosRecords[itemSeleccionado.index].nacfam,
            fecnac: datosFamiliar.fecnac || nuevosRecords[itemSeleccionado.index].fecnac,
            parent: datosFamiliar.parent || nuevosRecords[itemSeleccionado.index].parent,
            estudia: datosFamiliar.estudia,
            gradoestudio: datosFamiliar.gradoestudio || nuevosRecords[itemSeleccionado.index].gradoestudio,
            instituto: datosFamiliar.instituto || nuevosRecords[itemSeleccionado.index].instituto
          };
        }
      } else if (operacion === 3) {
        // Eliminar familiar
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          nuevosRecords = nuevosRecords.filter((_, i) => i !== itemSeleccionado.index);
        }
      }

      setRecords(nuevosRecords);
      setItemSeleccionado(null);
      props.onDataChange(nuevosRecords);
      setMostrar(false);


    } else {
     

      actualizarFamiliarBD(datosFamiliar);

    }
  };

  const seleccionarFila = (item, index) => (e) => {
    e.preventDefault();

    // Crear un objeto con la estructura que espera el modal
    const itemParaModal = {
      cedfam: item.cedfam,
      nomfam: item.nomfam,
      sexfam: item.sexfam,  // 1 o 2
      nacfam: item.nacfam,
      fecnac: item.fecnac,
      parent: item.parent,
      estfam: item.estudia,  // Cambiar de estudia a estfam
      graest: item.gradoestudio,  // Cambiar de gradoestudio a graest
      insest: item.instituto,  // Cambiar de instituto a insest
      index: index
    };

    setItemSeleccionado(itemParaModal);
  };

  const gestionarFamilia = (oper) => (e) => {
    e.preventDefault();

    // Validar que haya un item seleccionado para editar/eliminar/consultar
    if ((oper === 2 || oper === 3 || oper === 4) && !itemSeleccionado) {
      setMensaje({
        mostrar: true,
        titulo: "Advertencia",
        texto: "Debe seleccionar un familiar primero",
        icono: "warning"
      });
      return;
    }

    setOperacion(oper);
    setMostrar(true);
  };

  // Formatear fecha para mostrar
  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    return moment.utc(fecha).format('DD-MM-YYYY');
  };

  return (
    <div className="col-12 m-0 p-0">
      {/* Mensaje de notificación */}
      {mensaje.mostrar && (
        <div className={`alert alert-${mensaje.icono === 'error' ? 'danger' : mensaje.icono === 'success' ? 'success' : 'warning'} alert-dismissible fade show mb-2`} role="alert">
          <strong>{mensaje.titulo}:</strong> {mensaje.texto}
          <button type="button" className="close" onClick={() => setMensaje({ ...mensaje, mostrar: false })}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      )}

      <div className="col-12 m-0 p-0 d-flex">
        <div className="col-11 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records.length > 0 ? (
                records.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: 'pointer',
                      background: itemSeleccionado?.cedfam === item.cedfam ? "lightskyblue" : "white"
                    }}
                    onClick={seleccionarFila(item, index)}
                  >
                    <td className="text-center">{item.cedfam}</td>
                    <td className="text-center">{item.nomfam}</td>
                    <td className="text-center">{item.sexfam === 1 ? 'FEMENINO' : 'MASCULINO'}</td>
                    <td className="text-center">{item.nacfam}</td>
                    <td className="text-center">{formatearFecha(item.fecnac)}</td>
                    <td className="text-center">{item.parent}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    {activate ? 'Cargando...' : 'No hay familiares registrados'}
                  </td>
                </tr>
              )}
            </tbody>
          </TblContainer>
        </div>

        <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
          <div className="col-auto m-0 p-0">
            <button
              type="button"
              className="btn btn-info rounded-circle"
              onClick={gestionarFamilia(4)}
              disabled={records.length === 0 || !itemSeleccionado || activate}
              title="Consultar"
            >
              <i className="fa fa-eye"></i>
            </button>
          </div>

          <div className="col-auto m-0 p-0">
            <button
              type="button"
              className="btn btn-primary rounded-circle"
              onClick={gestionarFamilia(1)}
              disabled={activate}
              title="Incluir"
            >
              <i className="fa fa-plus"></i>
            </button>
          </div>

          <div className="col-auto m-0 p-0">
            <button
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={gestionarFamilia(3)}
              disabled={!itemSeleccionado || activate}
              title="Eliminar"
            >
              <i className="fa fa-trash-alt"></i>
            </button>
          </div>

          <div className="col-auto m-0 p-0">
            <button
              type="button"
              className="btn btn-warning rounded-circle"
              onClick={gestionarFamilia(2)}
              disabled={!itemSeleccionado || activate}
              title="Editar"
            >
              <i className="fa fa-edit"></i>
            </button>
          </div>
        </div>
      </div>

      <AgregarFamilias
        show={mostrar}
        onHide={() => {
          setMostrar(false);
          setItemSeleccionado(null);
        }}
        operacion={operacion}
        datos={itemSeleccionado}
        onAceptar={handleAceptarModal}
      />
    </div>
  );
}